import { Swiper } from 'swiper';
import { SwiperOptions } from 'swiper/types';
import { Navigation, Pagination, Autoplay, EffectFade } from 'swiper/modules'

Swiper.use([Navigation, Pagination, Autoplay, EffectFade]);

const _swiperOptions: any = {
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: true,
  }
}

const defaultSwiperOptions: SwiperOptions = {
  a11y: {
    firstSlideMessage: 'First slide',
    lastSlideMessage: 'Last slide',
    nextSlideMessage: 'Next slide',
    prevSlideMessage: 'Previous slide',
  },
  centerInsufficientSlides: true,
  centeredSlidesBounds: true,
  direction: 'horizontal',
  loop: false,
  navigation: true,
  on: {
    init: function (swiper) {
      wfUpdateActiveBackgroundItem(swiper);
      wfUpdateActiveContentSyncItem(swiper);
      wfUpdateActiveNavbarButton(swiper);
      wfInitializeNavButtons(swiper);
    },
    slideChange: function (swiper) {
      wfUpdateActiveBackgroundItem(swiper);
      wfUpdateActiveContentSyncItem(swiper);
      wfUpdateActiveNavbarButton(swiper);
    },
  },
  observer: true,
  observeParents: true,
  pagination: true,
  slideVisibleClass: 'swiper-slide-visible',
  slidesPerView: 1,
  spaceBetween: 20,
  speed: 500,
  watchOverflow: true,
  watchSlidesProgress: true,
};

function wfUpdateActiveNavbarButton(swiperInstance: Swiper) {
  let navbars = swiperInstance.el.closest('.page-component')?.querySelectorAll<HTMLElement>('.swiper-navbar');
  if (navbars) {
    navbars.forEach((navbar) => {
      const allNavbarButtons = navbar.querySelectorAll('.swiper-navbar-button');
      allNavbarButtons.forEach((button) => {
        button.classList.remove('swiper-navbar-button-active');
      });
      const currentNavbarButton = allNavbarButtons.item(swiperInstance.realIndex);
      if (currentNavbarButton) {
        currentNavbarButton.classList.add('swiper-navbar-button-active');
      }
    });
  }
}

function wfUpdateActiveBackgroundItem(swiperInstance: Swiper) {
  let background = swiperInstance.el.closest('.page-component')?.querySelector<HTMLElement>('.swiper-background');
  if (background) {
    let backgroundItems = background.querySelectorAll<HTMLElement>('.swiper-background-item');
    backgroundItems.forEach((item) => {
      item.classList.remove('swiper-background-item-active');
    });
    const currentBackgroundItem = backgroundItems.item(swiperInstance.realIndex);
    if (currentBackgroundItem) {
      currentBackgroundItem.classList.add('swiper-background-item-active');
    }
  }
}

function wfUpdateActiveContentSyncItem(swiperInstance: Swiper) {
  let contentSync = swiperInstance.el.closest('.page-component')?.querySelectorAll<HTMLElement>('.swiper-content-sync');
  if (contentSync) {
    contentSync.forEach((sync) => {
      let allSyncItems = sync.querySelectorAll<HTMLElement>('.swiper-content-sync-item');
      allSyncItems.forEach((item) => {
        item.classList.remove('active');
      });
      let currentSyncItem = allSyncItems.item(swiperInstance.realIndex);
      if (currentSyncItem) {
        currentSyncItem.classList.add('active');
      }
    });
  }
}

function wfInitializeNavButtons(swiperInstance: Swiper) {
  const wfSwiperNavPrevButtons = swiperInstance.el.closest('.page-component')?.querySelectorAll<HTMLElement>('.swiper-button-prev');
  const wfSwiperNavNextButtons = swiperInstance.el.closest('.page-component')?.querySelectorAll<HTMLElement>('.swiper-button-next');

  wfSwiperNavPrevButtons?.forEach((button) => {
    button.addEventListener('click', () => {
      swiperInstance.slidePrev();
    });
  });

  wfSwiperNavNextButtons?.forEach((button) => {
    button.addEventListener('click', () => {
      swiperInstance.slideNext();
    });
  });
}

function initializeSwiper(wrapperSelector: string, additionalOptions?: SwiperOptions): Swiper[] {
  const wrapperElements = document.querySelectorAll<HTMLElement>(wrapperSelector);
  const swipers: Swiper[] = [];

  wrapperElements?.forEach((wrapperElement) => {
    const swiperElement = wrapperElement.querySelector<HTMLElement>('.swiper');
    if (swiperElement) {
      const swiperDataOptions = JSON.parse(swiperElement.dataset.swiper || '{}');
      const options: SwiperOptions = { ...defaultSwiperOptions, ...additionalOptions, ...swiperDataOptions };

      if (options.autoplay) {
        options.autoplay = {
          delay: 10000,
        };
      }

      if (options.pagination) {
        options.pagination = {
          el: wrapperElement.querySelector<HTMLElement>(_swiperOptions.pagination.el)!,
          type: _swiperOptions.pagination.type,
          clickable: _swiperOptions.pagination.clickable,
        };
      }

      if (options.navigation) {
        options.navigation = {
          prevEl: wrapperElement.querySelector<HTMLElement>(_swiperOptions.navigation.prevEl)!,
          nextEl: wrapperElement.querySelector<HTMLElement>(_swiperOptions.navigation.nextEl)!,
        };
      }

      if (options.watchOverflow && swiperElement.querySelectorAll('.swiper-slide').length < 2) {
        options.loop = false;
      }

      const swiper = new Swiper(swiperElement, options);
      swipers.push(swiper);
    }
  });

  return swipers;
}

export function initializeSwiperInstances(): void {
  initializeSwiper('.hero-carousel', {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    },
  });

  initializeSwiper('.icons-carousel', {
    slidesPerView: 'auto',
    spaceBetween: 0,
    loop: true,
  });

  const amboyDirectHeroCarouselBaseSettings = {
    spaceBetween: 0,
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    },
    loop: true,
    on: {
      'activeIndexChange': function () {
        var productTrack = this.el.closest('.amboy-direct-hero-carousel')?.querySelector('.swiper-product-banner-nav .product-track');
        if (productTrack) {
          productTrack.querySelectorAll('.product-trigger').forEach((productTrigger) => {
            if (productTrigger.getAttribute('data-trigger-index') == this.realIndex) {
              productTrigger.classList.add('product-current');
            } else {
              productTrigger.classList.remove('product-current');
            }
          });
        }
        if (this.slides) {
          var activeIndex = this.activeIndex;
          this.slides.forEach((slide) => {
            var currentExplanationTarget = slide.querySelector('.handwriting .explanation');
            var explanationTarget = slide.querySelector('.handwriting .print-explanation');
            if (currentExplanationTarget && explanationTarget) {
              if (slide.getAttribute('data-swiper-slide-index') == activeIndex) {
                explanationTarget.innerHTML = "";
                setTimeout(() => {
                  writeAmboyDirectHeroCarouselExplanation(explanationTarget, currentExplanationTarget);
                }, 100);
              } else {
                explanationTarget.innerHTML = "";
              }
            }
          });
        }
      }
    }
  };

  initializeSwiper('.amboy-direct-hero-carousel:not(.auto-rotate)', amboyDirectHeroCarouselBaseSettings);

  initializeSwiper('.amboy-direct-hero-carousel.auto-rotate',{
    ...amboyDirectHeroCarouselBaseSettings,
    autoplay: true
  });

  initializeSwiper('.image-carousel', {
    slidesPerView: 'auto',
    spaceBetween: 0,
    loop: true
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initializeSwiperInstances();
});

function writeAmboyDirectHeroCarouselExplanation(target, explanationTarget) {
  var intervalId;
  intervalId = window.setInterval(function () {
    var currentLength = target.innerHTML.length;
    if (currentLength == explanationTarget.innerHTML.length) {
      window.clearInterval(intervalId);
    }
    target.innerHTML = explanationTarget.innerHTML.substring(0, currentLength + 1);
  }, 100);
}
